import {LOCALES, TEXT_DIRECTIONS, type TextDirection} from '../constants/locales';

export const isRtlLocale = (locale?: string): boolean => locale === LOCALES.ARABIC;

export const getTextDirection = (locale?: string): TextDirection => (isRtlLocale(locale) ? TEXT_DIRECTIONS.RTL : TEXT_DIRECTIONS.LTR);
